module.exports = __webpack_public_path__ + "static/img/brees-2016-slide-7.b353c29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2016-slide-7.jpg
// module id = JO5a
// module chunks = 1